import Schema from "nexia_mobile/models/schema";

export default {
  parseLinksEdit(links) {
    let link = _.first(links);

    if (link) {
      let SchemaClass = this.getEditSchemaClass();
      let schema = new SchemaClass(link.getData(), { parse: true });
      schema.parentModel = this; // so the edit schema can be used to delete its parent resource
      schema.setUrl(link.href);
      schema.setStoredOnServer(link.isPostLink());
      this._editSchema = schema;
    }
  },

  parseLinksTemplate(links) {
    return this.parseLinksEdit(links);
  },

  createEditSchema() {
    if (this._editSchema) {
      return this._editSchema.prepare();
    } else {
      return Promise.reject(
        new Error(
          "Attempted to create an edit schema for a model that had no edit link"
        )
      );
    }
  },

  _createSchemaFromAttrs(attrs) {
    let SchemaClass = this.getEditSchemaClass();
    this._editSchema = new SchemaClass(attrs, { parse: true });
  },

  isEditable() {
    return Boolean(this._editSchema);
  },

  getEditSchemaClass() {
    return Schema;
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/editable.js